import type { GroupAccess } from "@soundsgoodas/sg-common";
import { GroupCard } from "./GroupCard";

interface GroupsListProps {
  groups: Record<string, GroupAccess> | undefined;
}

export function GroupsList({ groups }: GroupsListProps) {
  if (!groups) return null;

  const activeGroups = Object.entries(groups).filter(
    ([, group]) => group.status !== "deleted"
  );

  if (activeGroups.length === 0) return null;

  return (
    <div className="mt-4">
      <h4 className="mb-3 text-sm font-semibold text-(--text-muted,#6b7280)">Groups</h4>
      <div className="flex flex-col gap-2">
        {activeGroups.map(([groupId, group]) => (
          <GroupCard key={groupId} groupId={groupId} group={group} />
        ))}
      </div>
    </div>
  );
}
